module.exports = __webpack_public_path__ + "img/arrowDownDetails.9d0a94e2.svg";